module.exports = __webpack_public_path__ + "img/1.13_Russian_road_sign.08de2503.svg";